import PrintReportSummary from '../../components/dailyReport/print/PrintReportSummary';
import PrintProgramMetrics from '../../components/dailyReport/print/PrintProgramMetrics';
import PrintCurrentDrillingLocations from '../../components/dailyReport/print/PrintCurrentDrillingLocations';
import PrintDrillingInProgressHole from '../../components/dailyReport/print/PrintDrillingInProgressHole';

export const DAILY_REPORT_SECTIONS = [
  {
    id: 'coverPage',
    label: 'Cover page',
    renderType: 'cover',
  },
  {
    id: 'reportSummary',
    label: 'Report summary',
    pageTitle: 'Minto Daily Report',
    renderType: 'react',
    Component: PrintReportSummary,
    getProps: ({ narrative, reportDateLabel }) => ({
      narrative,
      reportDateLabel,
    }),
  },
  {
    id: 'programMetrics',
    label: 'Program metrics',
    pageTitle: 'Program Metrics',
    getPageSubtitle: ({ campaignLabel }) =>
      campaignLabel ? `Campaign: ${campaignLabel}` : null,
    contentPaddingPx: 4,
    renderType: 'react',
    Component: PrintProgramMetrics,
    getProps: ({ drillingMetrics, sampleMetrics, campaignLabel }) => ({
      drillingMetrics,
      sampleMetrics,
      campaignLabel,
    }),
  },
  {
    id: 'currentDrillingLocations',
    label: 'Current drilling locations',
    pageTitle: 'Current Drilling Locations',
    getPageSubtitle: ({ mapReportContext, campaignLabel }) => {
      const label = mapReportContext?.campaignLabel || campaignLabel;
      return label ? `${label} Program Progress By Zone:` : 'Program Progress By Zone:';
    },
    contentPaddingPx: 4,
    renderType: 'react',
    Component: PrintCurrentDrillingLocations,
    getProps: ({ mapReportContext }) => ({
      mapSnapshotDataUrl: mapReportContext?.mapSnapshotDataUrl,
      zoneLegend: mapReportContext?.zoneLegend,
      campaignLabel: mapReportContext?.campaignLabel,
    }),
    isApplicable: ({ mapReportContext }) => Boolean(mapReportContext?.mapSnapshotDataUrl),
  },
  {
    id: 'drillingInProgress',
    label: 'Drilling in progress',
    renderType: 'holePages',
    Component: PrintDrillingInProgressHole,
    getPages: ({ inProgressHolePages }) => inProgressHolePages ?? [],
    getPageTitle: (hole) => hole.pageTitle,
    getPageSubtitle: (hole) => hole.pageSubtitle,
    isApplicable: ({ inProgressHolePages, hasInProgressSelection }) =>
      (inProgressHolePages?.length ?? 0) > 0 || Boolean(hasInProgressSelection),
  },
];

export const DAILY_REPORT_PRESETS = {
  minimal: {
    coverPage: true,
    reportSummary: true,
    programMetrics: false,
  },
  standard: {
    coverPage: true,
    reportSummary: true,
    programMetrics: true,
    currentDrillingLocations: true,
    drillingInProgress: true,
  },
  /** @deprecated Use `standard` — kept for saved UI state compatibility */
  sampleProgress: {
    coverPage: true,
    reportSummary: true,
    programMetrics: true,
    currentDrillingLocations: true,
    drillingInProgress: true,
  },
  custom: null,
};

export const DEFAULT_DAILY_REPORT_PRESET = 'standard';

export function getDefaultSelectedSections(preset = DEFAULT_DAILY_REPORT_PRESET) {
  const config = DAILY_REPORT_PRESETS[preset];
  if (!config) {
    return { ...DAILY_REPORT_PRESETS.standard };
  }
  return { ...config };
}

export function getSectionDefinitionsForUi() {
  return DAILY_REPORT_SECTIONS.filter((section) => section.id !== 'coverPage').map(
    ({ id, label }) => ({ id, label })
  );
}

export function getApplicableSections(selectedSections, context) {
  return DAILY_REPORT_SECTIONS.filter((section) => {
    if (!selectedSections[section.id]) return false;
    if (typeof section.isApplicable === 'function') {
      return section.isApplicable(context);
    }
    return true;
  });
}
